import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8.333 2.5v1.667H4.167v11.666h11.666v-4.166H17.5v5a.833.833 0 0 1-.833.833H3.333a.833.833 0 0 1-.833-.833V3.333a.833.833 0 0 1 .833-.833zm6.322 1.667h-3.822V2.5H17.5v6.667h-1.667V5.345L10 11.178 8.822 10z"
    }, null, -1)
  ]))]))
}
export default { render: render }